import OpenAI from 'openai';

const openai = new OpenAI({
  apiKey: import.meta.env.VITE_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true
});

export const transcribeAudio = async (audioBlob: Blob): Promise<string> => {
  try {
    // Convert blob to File object as required by OpenAI
    const file = new File([audioBlob], 'audio.webm', { type: 'audio/webm' });
    
    const response = await openai.audio.transcriptions.create({
      file: file,
      model: 'whisper-1',
    });
    
    return response.text;
  } catch (error) {
    console.error('Transcription error:', error);
    return '';
  }
};

export const synthesizeSpeech = async (text: string): Promise<ArrayBuffer> => {
  try {
    const response = await openai.audio.speech.create({
      model: 'tts-1',
      voice: 'alloy',
      input: text,
    });
    
    const arrayBuffer = await response.arrayBuffer();
    return arrayBuffer;
  } catch (error) {
    console.error('Speech synthesis error:', error);
    throw error;
  }
};